<template>
    <table>
        <tr>
            <th class="table-number-header">№</th>
            <th class="table-questions-header">ВОПРОСЫ</th>
        </tr>
        <tr v-for="(item, key) in questions" :key="key" v-bind:style="{backgroundColor: item.row_color}">
            <td class="table-number"><vue-markdown>{{item.name}}</vue-markdown></td>
            <td class="table-questions"><vue-markdown>{{item.body}}</vue-markdown></td>
        </tr>
    </table>
</template>

<script>
    import VueMarkdown from 'vue-markdown'
    export default {
        name: "Questions",
        props: ['questions'],
        components: {
            VueMarkdown
        }
    }
</script>

<style scoped>
    table {
        margin-top: 25px;
        width: 100%;
    }

    table, th, td {

        border: 1px solid black;
        border-collapse: collapse;
    }

    th, td {
        padding: 5px;
        text-align: left;
    }

    .table-number, .table-number-header {
        width: 5%;
    }

    .table-number, .table-number-header, .table-questions-header {
        text-align: center;
    }

    .table-number-header, .table-questions-header {
        background-color: darkgray;
    }

</style>